import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AIIcon } from '../AI-Icon';
import CarolinaChatPanel from './CarolinaChatPanel.tsx';
import { useBrand } from '../../../context/BrandContext';
import './styles.css';

interface CarolinaFabProps {
  isMobileOpen?: boolean;
}

export function CarolinaFab({ isMobileOpen = false }: CarolinaFabProps) {
  const { t } = useTranslation();
  const { brand } = useBrand();
  const [carolinaOpen, setCarolinaOpen] = useState(false);
  const [carolinaClosing, setCarolinaClosing] = useState(false);

  const toggleCarolina = useCallback(() => {
    if (carolinaOpen) {
      setCarolinaClosing(true);
      setTimeout(() => {
        setCarolinaOpen(false);
        setCarolinaClosing(false);
      }, 220);
    } else {
      setCarolinaOpen(true);
    }
  }, [carolinaOpen]);

  const label = t('reports.menuAskCarolina', 'Preguntar a Carolina');

  return (
    <div className="sidebar-item carolina-fab-item">
      <button
        className={`sidebar-link carolina-fab${carolinaOpen ? ' active carolina-fab--active' : ''}`}
        type="button"
        title={!isMobileOpen ? `${brand.assistantName} AI` : undefined}
        onClick={toggleCarolina}
      >
        <span className="sidebar-icon">
          <AIIcon size={24} starScale={1.5} className="carolina-fab-icon" followMouse={false} />
        </span>
        {isMobileOpen && <span className="sidebar-text">{label}</span>}
      </button>
      <CarolinaChatPanel isOpen={carolinaOpen} isClosing={carolinaClosing} onClose={toggleCarolina} />
    </div>
  );
}
